import React, { Component } from 'react';
import JobToShow from './JobToShow.js';
import Collapse from '@material-ui/core/Collapse';


const datefor = new Intl.DateTimeFormat('en-GB', {
	weekday: 'short',
	year: 'numeric',
	month: 'short',
	day: '2-digit'
});

export default class DateWiseJobs extends Component {
	constructor(props) {
		super(props);
		this.state = {
			open: true
		}
		this.changeOpen = this.changeOpen.bind(this);
		this.jobDetails = this.jobDetails.bind(this);
	}

	changeOpen() {
		this.setState({
			open: !this.state.open
		});
	}

	jobDetails(jobDetailsToShow) {
		if (jobDetailsToShow) {
			this.props.jobDetails(jobDetailsToShow);
		}
	}

	getJobs(jobs) {
		var jobsData = jobs.map((job, index) => {
			return (
				<div key={index} style={{ padding: '0 3px 3px 3px' }}>
					<JobToShow job={job} operationType={this.props.operationType} jobDetails={this.jobDetails} />
				</div>
			);
		});
		return jobsData;
	}

	render() {
		return (
			<div className="putaway-pallet-outer">
				<div>
					<div className="date-wise-prod-box" style={{ cursor: 'pointer' }} onClick={this.changeOpen}>
						<div className="row">
							<div className="col-xs-5 col-sm-4 col-md-3">
								{datefor.format(this.props.date.date)}
							</div>
							<div className="col-xs-4 col-sm-4 col-md-4" style={{ color: '#797979' }}>
								{this.props.date.jobs.length} products
							</div>
							<div className="col-xs-3 col-sm-4 col-md-5" style={{ textAlign: 'right' }}>
								{(this.state.open) ?
									<i className="fas fa-chevron-up"></i>
									:
									<i className="fas fa-chevron-down"></i>
								}
							</div>
						</div>
					</div>
					<div>
						<Collapse in={this.state.open}>
							<div>
								{this.getJobs(this.props.date.jobs)}
							</div>
						</Collapse>
					</div>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/screens/JobOperations/Components/Commons/DateWiseJobs.js